import React from "react";
import "./NotFound.css";

export default function NotFound() {
  return (
  <>
    <h1 className="not-found">sorry, page not found. please return to homepage.</h1>
  </>
  );
}